import React, { useContext } from 'react';
import DOMPurify from 'dompurify';

import Confirmation from './Confirmation.jsx';
import Button from './Button.jsx';

import TranslationsContext from '../TranslationsContext';

export default function SummaryStep({
	subscriptionProducts,
	subscriptionsDetails,
	depositedData,
	setDepositedData,
	currentDog,
	step,
	setStep,
	setConsentIsClicked,
	consentIsClicked,
	tableType,
	sectionsAlreadyOnThePage,
	listProductHandles,
	setDepositedDataReset,
	thankYouPageHandle,
	navigate,
	findSubscriptionAndAddToCart,
	setWidgetError,
	formatMoney,
}) {
	const t = useContext(TranslationsContext);

	return (
		<>
			<Confirmation
				subscriptionProducts={subscriptionProducts}
				subscriptionsDetails={subscriptionsDetails}
				depositedData={depositedData}
				setDepositedData={setDepositedData}
				currentDog={currentDog}
				step={step}
				setConsentIsClicked={setConsentIsClicked}
				consentIsClicked={consentIsClicked}
				tableType={tableType}
				formatMoney={formatMoney}
			/>
			<div
				className="subscriptions-configurator__buttons-wrapper column small-12 flex-container flex-dir-row align-spaced section-spacing-padding flex-wrap"
				style={{ gap: '10px' }}
			>
				<Button type="button" action={step - 1} setStep={setStep} text={t('back')} classname="button button--border-green white" />
				<button
					className="button  button--gradient-add-to-cart"
					onClick={async (e) => {
						if (consentIsClicked == true) {
							setWidgetError('');
							e.target.classList.add('loading');
							await findSubscriptionAndAddToCart();
							setTimeout(() => {
								window.scrollTo({ top: 0, behavior: 'smooth' });
								if (thankYouPageHandle !== '' && thankYouPageHandle !== undefined && thankYouPageHandle !== 'false') {
									document.dispatchEvent(
										new CustomEvent('fetch--page--template', {
											bubbles: true,
											detail: {
												handle: thankYouPageHandle,
												selector: '#subscriptionsConfiguratorThankYouPage',
											},
										}),
									);
								}
								navigate('/pages/subscriptions/thank-you');
								setStep(5);
								setDepositedDataReset(listProductHandles);
							}, 4000);
						} else {
							setWidgetError(t('error_consent_required'));
							document.querySelector('#consent')?.focus();
						}
					}}
				>
					<span style={{ pointerEvents: 'none' }}>{t('confirm_subscription')}</span>
				</button>
			</div>
			<div className="column small-12 flex-container flex-dir-column align-middle confirmation-wrapper">
				<div className="columns flex-container flex-dir-column confirmation-wrapper__box" style={{ maxWidth: '800px' }}>
					<div className="outro-content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sectionsAlreadyOnThePage[4]) }} />
				</div>
			</div>
		</>
	);
}
